/* -------------------------------------------------------------------------- */
/* --------------------------- THEME : FRAMEWORKS --------------------------- */

// FRAMEWORKS : NODES_MODULES
import gsap from "gsap";
import "gsap/EasePack";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
// import ScrollSmoother from "gsap/ScrollSmoother";
// import MotionPathPlugin from "gsap/MotionPathPlugin";
gsap.registerPlugin(ScrollTrigger, SplitText);

import Swiper from "swiper";
import {
	Autoplay,
	// Navigation,
	// Thumbs,
	// EffectFade,
	// Navigation,
	Pagination,
	Scrollbar,
} from "swiper/modules";

/* -------------------------------------------------------------------------- */
/* ------------------------ THEME : GLOBAL VARIABLES ------------------------ */

// Default : Smooth scrolling
let scrollSmooth = false;

/* -------------------------------------------------------------------------- */
/* ------------------------- THEME : GLOBAL EVENTS -------------------------- */

// DOCUMENT READY :
document.addEventListener("DOMContentLoaded", () => {
	// remove 'page-no-js' body class
	document.body.classList.remove("page-no-js");
	gsapPreloader();
	scrollDetection(160);
	menuBurger();
	menuDropdown();
	bannerInit();
	bannerToMarquee();
	dataPopin();
	dataToggle();
	dataAccordion();
	swiperInit();
});

// DOCUMENT RESIZED (avec ScrollTrigger)
ScrollTrigger.addEventListener("refreshInit", () => {
	gsapScrollSmootherRefresh();
	bannerToMarquee();
});

/* -------------------------------------------------------------------------- */
/* ----------------------- THEME : GLOBAL FUNCTIONS ------------------------- */

// Activation/désactivation du scroll
function scrollEnabled(bool) {
	if (bool === false || bool === true) {
		const enableScroll = bool === true;

		if (scrollSmooth) {
			scrollSmooth.paused(!enableScroll);
		}

		document.documentElement.style.overflowY = enableScroll ? "auto" : "hidden";
	}
}

// Scroll vers une ancre
const scrollToAnchor = (scrollOffset = 0) => {
	// Fonction pour gérer le défilement
	const scrollToElement = (target) => {
		const element = document.querySelector(target);
		if (element) {
			if (scrollSmooth) {
				// Avec ScrollSmoother
				scrollSmooth.scrollTo(target, true, `top ${scrollOffset}px`);
			} else {
				// Par défaut
				window.scrollTo({
					top:
						element.getBoundingClientRect().top + window.scrollY - scrollOffset,
					behavior: "smooth",
				});
			}
		}
	};

	// au chargement
	const hashInUrl = window.location.hash;
	if (hashInUrl) {
		scrollToElement(hashInUrl);
	}

	// avec un [href="#..."]
	const linksWithAnchor = document.querySelectorAll('a[href^="#"]');
	linksWithAnchor.forEach((link) => {
		link.addEventListener("click", (event) => {
			const anchorHref = link.getAttribute("href");
			if (anchorHref !== "#") {
				event.preventDefault();
				scrollToElement(anchorHref);
			}
		});
	});

	// avec un [data-scrollto]
	const dataWithScrollTo = document.querySelectorAll("[data-scrollto]");
	dataWithScrollTo.forEach((data) => {
		data.addEventListener("click", () => {
			let anchorData = data.getAttribute("data-scrollto");
			if (anchorData === "auto") {
				// Calculer la position de défilement pour 'auto'
				const autoOffset = window.innerHeight + window.scrollY - scrollOffset;
				window.scrollTo({
					top: autoOffset,
					behavior: "smooth",
				});
			} else {
				// Utiliser la valeur de data-scrollto comme cible pour scrollToElement
				scrollToElement(anchorData);
			}
		});
	});
};

// Détection du scroll sur le body
const scrollDetection = (scrollOffset = 1) => {
	let position = window.scrollY;

	if (position > scrollOffset) {
		document.body.classList.add("page-scrolled");
	} else {
		document.body.classList.remove("page-scrolled");
	}

	document.addEventListener("scroll", () => {
		// Détecter la direction du scroll
		let scroll = window.scrollY;
		// Scroll vers le bas
		if (scroll > position) {
			if (scroll < scrollOffset) {
				document.body.classList.remove("page-scrolled");
				document.body.classList.remove("page-scrolling");
			} else {
				document.body.classList.add("page-scrolling");
				document.body.classList.add("page-scrolled");
			}
		}
		// Scroll vers le haut
		else {
			document.body.classList.remove("page-scrolling");
			if (scroll < scrollOffset) {
				document.body.classList.remove("page-scrolled");
			}
		}
		// Scroll max ?
		if (scroll + window.innerHeight >= document.documentElement.scrollHeight) {
			document.body.classList.add("page-scroll-completed");
		} else {
			document.body.classList.remove("page-scroll-completed");
		}
		position = scroll;
	});
};

// Gestion du menu burger
const menuBurger = () => {
	const headerBurger = document.querySelector("#page-header-burger");
	const headerBackdrop = document.querySelector("#page-header-backdrop");

	if (headerBurger) {
		headerBurger.addEventListener("click", () => {
			if (document.body.classList.contains("page-with-fullscreenmenu")) {
				scrollEnabled(true);
				document.body.classList.remove("page-with-fullscreenmenu");
			} else {
				scrollEnabled(false);
				document.body.classList.add("page-with-fullscreenmenu");
			}
		});
	}

	if (headerBackdrop) {
		headerBackdrop.addEventListener("click", () => {
			if (document.body.classList.contains("page-with-fullscreenmenu")) {
				scrollEnabled(true);
				document.body.classList.remove("page-with-fullscreenmenu");
			} else {
				scrollEnabled(false);
				document.body.classList.add("page-with-fullscreenmenu");
			}
		});
	}

	const closeMenuButton = document.querySelector(
		".header__fullscreenmenu__close"
	);
	if (closeMenuButton) {
		closeMenuButton.addEventListener("click", (e) => {
			e.preventDefault();
			if (document.body.classList.contains("page-with-fullscreenmenu")) {
				scrollEnabled(true);
				document.body.classList.remove("page-with-fullscreenmenu");
			} else {
				scrollEnabled(false);
				document.body.classList.add("page-with-fullscreenmenu");
			}
		});
	}
};

// Gestion des dropdowns
const menuDropdown = () => {
	const menuItemLinks = document.querySelectorAll(
		'.menu .menu__item .menu__link[href="#"]'
	);

	menuItemLinks.forEach((item) => {
		item.closest(".menu__item").classList.add("menu__item--parent");
		item.addEventListener("click", (event) => {
			event.preventDefault();
			item.closest(".menu__item").classList.toggle("menu__item--active");
		});
	});

	document.addEventListener("mouseup", (event) => {
		const activeMenuItems = document.querySelectorAll(
			".menu .menu__item.menu__item--active"
		);

		activeMenuItems.forEach((activeItem) => {
			if (
				!activeItem.isEqualNode(event.target) &&
				!activeItem.contains(event.target)
			) {
				activeItem.classList.remove("menu__item--active");
			}
		});
	});
};

// Activation/désactivation de la bannière
const bannerInit = () => {
	// Vérifie si la bannière a déjà été fermée durant cette session
	if (sessionStorage.getItem("bannerClosed") === "true") {
		return;
	}

	const pageBanner = document.querySelector("#page-banner");
	const pageBannerClose = document.querySelector("#page-banner-close");

	if (pageBanner) {
		// actualisation
		document.body.classList.add("page-with-banner");
		// bouton de fermeture
		pageBannerClose.addEventListener("click", () => {
			document.body.classList.remove("page-with-banner");

			// Enregistre en session que la bannière a été fermée
			sessionStorage.setItem("bannerClosed", "true");
		});
	}
};

// Gestion du défilement horizontal de la bannière
const bannerToMarquee = () => {
	const pageBanner = document.querySelector("#page-banner");

	if (pageBanner) {
		const bannerwrapperWidth = pageBanner.offsetWidth;
		const bannerTextWidth =
			pageBanner.querySelector(".banner__text").offsetWidth;
		if (bannerwrapperWidth > bannerTextWidth + 60) {
			pageBanner.classList.remove("page__banner--scrolling");
		} else {
			pageBanner.classList.add("page__banner--scrolling");
		}
	}
};

// Gestions des actions des [data-toggle]
const dataToggle = () => {
	// Récupération de tous les écouteurs
	const toggleListeners = document.querySelectorAll("[data-toggle]");

	// Écouteur d'événement pour chaque écouteur
	toggleListeners.forEach((togglelistener) => {
		const toggleTargetSelector = togglelistener.dataset.toggle;
		const toggleTarget = toggleTargetSelector
			? document.querySelector(toggleTargetSelector)
			: null;

		togglelistener.addEventListener("click", (event) => {
			if (toggleTarget) {
				// event.stopPropagation();
				toggleTarget.classList.toggle("--active");
			}
		});
	});

	// Gestionnaire pour les clics hors des éléments toggle
	document.addEventListener("click", (event) => {
		toggleListeners.forEach((togglelistener) => {
			const toggleTargetSelector = togglelistener.dataset.toggle;
			const toggleTarget = toggleTargetSelector
				? document.querySelector(toggleTargetSelector)
				: null;
			if (
				toggleTarget &&
				toggleTarget.classList.contains("--active") &&
				!toggleTarget.contains(event.target) &&
				!togglelistener.contains(event.target)
			) {
				toggleTarget.classList.remove("--active");
			}
		});
	});
};

// Gestions des actions des [data-accordion]
const dataAccordion = () => {
	const accordionListeners = document.querySelectorAll("[data-accordion]");

	accordionListeners.forEach((accordionElement) => {
		accordionElement.addEventListener("click", (event) => {
			event.stopPropagation();

			// Retirer la classe "--active" à tous les accordionListeners et accordionTargets
			accordionListeners.forEach((element) => {
				if (element !== accordionElement) {
					const accordionTarget = document.getElementById(
						element.dataset.accordion
					);
					if (accordionTarget) {
						element.classList.remove("--active");
						accordionTarget.classList.remove("--active");
					}
				}
			});

			// Ajouter la classe "--active" à la cible
			if (accordionElement.dataset.accordion) {
				const currentaccordionTarget = document.getElementById(
					accordionElement.dataset.accordion
				);
				if (currentaccordionTarget) {
					accordionElement.classList.add("--active");
					currentaccordionTarget.classList.add("--active");
				}
			}
		});
	});
};

// Gestions des actions des [data-popin]
const dataPopin = () => {
	const popins = document.querySelectorAll("[data-popin]");

	popins.forEach((popin) => {
		popin.addEventListener("click", (event) => {
			// event.preventDefault();

			// ouvrir/fermer la popin
			const thispopinName = popin.dataset.popin;
			if (thispopinName) {
				const thispopinEl = document.querySelector(
					`.page__popin#${thispopinName}`
				);
				thispopinEl.classList.toggle("page__popin--open");
			}

			// mettre les vidéos des popins en pause
			const htmlVideoFrompopin =
				document.querySelectorAll(".page__popin video");
			if (htmlVideoFrompopin.length > 0) {
				htmlVideoFrompopin.forEach((video) => {
					video.pause();
				});
			}
		});
	});
};

// Convertir les [data-src] en [src]
const dataSrc = () => {
	// Select all elements with a data-src attribute
	const srcElements = document.querySelectorAll("[data-src]");
	srcElements.forEach((element) => {
		element.setAttribute("src", element.getAttribute("data-src"));
		element.removeAttribute("data-src");
	});
};

/* -------------------------------- (SWIPER) -------------------------------- */

// Swiper : Initialisation des sliders
const swiperInit = () => {
	if (
		document.querySelectorAll("#autres-articles .swiper .swiper-slide").length >
		1
	) {
		new Swiper("#autres-articles .swiper", {
			// Core parameters
			slidesPerView: "auto",
			speed: 1200,
			resizeObserver: true,
			// Modules
			modules: [Scrollbar],
			scrollbar: {
				el: "#autres-articles .swiper-scrollbar",
				draggable: true,
			},
		});
	}

	if (document.querySelector("#team-swiper")) {
		let teamSwiper = new Swiper("#team-swiper", {
			slidesPerView: 2,
			breakpoints: {
				992: {
					slidesPerView: 3.5,
				},
				1200: {
					slidesPerView: "auto",
				},
			},
			spaceBetween: 30,
			loop: true,
			speed:
				document.querySelectorAll("#team-swiper .swiper-slide").length * 300,
			resizeObserver: true,
			modules: [Autoplay],
			autoplay: {
				delay: 0.1,
				disableOnInteraction: false,
			},
		});
		setTimeout(() => {
			// console.log("autoplay")
			teamSwiper.autoplay.start();
		}, 5000);
	}

	if (document.querySelector("#testimonials-swiper")) {
		new Swiper("#testimonials-swiper", {
			slidesPerView: 1,
			spaceBetween: 30,
			resizeObserver: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			pagination: {
				el: ".swiper-pagination",
				type: "bullets",
			},
			modules: [Autoplay, Pagination],
		});
	}

	if (document.querySelector("#logos-swiper")) {
		new Swiper("#logos-swiper", {
			slidesPerView: 3,
			loop: true,
			resizeObserver: true,
			autoplay: {
				delay: 1500,
				disableOnInteraction: false,
				reverseDirection: true,
			},
			modules: [Autoplay],
			breakpoints: {
				767: {
					slidesPerView: 4,
					spaceBetween: 20,
				},
				992: {
					slidesPerView: 6.5,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 7.5,
					spaceBetween: 30,
				},
			},
		});
	}
};

/* --------------------------------- (GSAP) --------------------------------- */

// GSAP : Initialisation du scrollSmoother (avec ScrollSmoother)
const initScrollSmooth = () => {
	scrollSmooth = ScrollSmoother.create({
		wrapper: "#page-wrapper",
		content: "#page-container",
		smooth: 2,
		smoothTouch: false,
		effects: true,
		normalizeScroll: false,
		ignoreMobileResize: true,
	});
};

// GSAP : Découpage des textes (avec SplitText)
const gsapSplitText = () => {
	const textsToAnimated = document.querySelectorAll([
		// global
		'[data-animation^="reveal-text"]',
		".elementor-heading-title",
		".exerg.elementor-widget p",
	]);

	textsToAnimated.forEach((_thisText) => {
		new SplitText(_thisText, {
			tag: "span",
			// type: "lines, words, chars",
			type: "words",
			linesClass: "line",
			wordsClass: "word",
			charsClass: "char",
		});
	});
};

// GSAP : Animations au scroll (avec ScrollTrigger)
const gsapDataAnimation = () => {
	// [data-animation] + .elementor-element
	const elementsToAnimated = document.querySelectorAll([
		"[data-animation]",
		".elementor-heading-title",
		".exerg.elementor-widget p",
		".elementor-element > .elementor-element > .elementor-element:not([data-animation])",
	]);
	elementsToAnimated.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		ScrollTrigger.create({
			trigger: _this,
			start: "top 100%",
			end: "bottom 0",
			onEnter: () => {
				setTimeout(() => {
					_this.classList.add("--animated");
				}, delay);
			},
			onLeaveBack: () => {
				_this.classList.remove("--animated");
			},
			// markers: true,
		});
	});

	// data-animation="counter"
	const elementsToCounter = document.querySelectorAll(
		'[data-animation="counter"]'
	);
	elementsToCounter.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		ScrollTrigger.create({
			trigger: _this,
			start: "top 100%",
			end: "bottom 0%",
			// markers: true,
			onEnter: () => {
				setTimeout(() => {
					gsap.from(_this, {
						duration: 1.5,
						textContent: 0,
						snap: { textContent: 1 },
						stagger: {
							each: 1.0,
							onUpdate: function () {
								this.targets()[0].innerHTML = Math.ceil(
									this.targets()[0].textContent
								)
									// conserver les "."
									.toString()
									.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
									// conserver les espaces
									.toString()
									.replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;");
							},
						},
					});
				}, delay);
			},
		});
	});

	// data-animation="reveal-text-reading"
	const textsToReading = document.querySelectorAll([
		'[data-animation="reveal-text-reading"]',
	]);
	textsToReading.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		gsap.fromTo(
			_this.querySelectorAll(".word"),
			{
				opacity: 0.33,
			},
			{
				delay: delay,
				stagger: 0.3,
				ease: "power1.out",
				opacity: 1,
				scrollTrigger: {
					trigger: _this,
					start: "top 88%",
					end: "top 22%",
					scrub: true,
					// markers: true,
				},
			}
		);
	});

	// data-animation="skid"
	const elementsToskid = document.querySelectorAll([
		'body:not(.elementor-editor-active) [data-animation="skid"]',
	]);
	elementsToskid.forEach((_this) => {
		gsap.to(_this, {
			scrollTrigger: {
				trigger: _this,
				pin: true,
				pinSpacing: false,
				start: "top top",
				// markers: true,
			},
		});
	});

	// CHRIS

	if (document.querySelector("#section-dates")) {
		if (window.innerWidth > 992) {
			// gsap.set('#celiance-timeline', {width:document.querySelectorAll('#section-dates .date') * 500})
			gsap.set("#celiance-timeline", {
				height: document.querySelector("#celiance-timeline").offsetWidth,
			});
			// console.log(document.querySelector("#celiance-timeline").offsetWidth)
			gsap.to("#celiance-timeline", {
				scrollTrigger: {
					trigger: "#celiance-timeline",
					start: "top 40%",
					end: () =>
						"+=" +
						(document.querySelector("#celiance-timeline").offsetWidth -
							window.innerHeight / 2),
					pin: true,
					scrub: true,
					onUpdate: (e) => {
						// console.log(e);
						gsap.to("#celiance-timeline .triangle", {
							x:e.progress * ( document.querySelector("#celiance-timeline").offsetWidth - window.innerWidth / 2) ,
								//e.progress * (document.querySelector("#celiance-timeline").offsetWidth + window.innerWidth / 2),
							rotateZ: e.progress * -90,
							ease:"none"
						});
						gsap.to("#section-dates .background", {
							backgroundImage:
								"linear-gradient(" +
								(90 + 270 * e.progress) +
								"deg, #f1f6f8 50%, #a2e8f0 100%)",
							duration: 1,
						});
					},
				},
				x:
					-document.querySelector("#celiance-timeline").offsetWidth +
					window.innerWidth / 2,
				ease:"none"
				// ease:'Power2.easeIn'
			});
		}
	}

	if (
		document.querySelector(".button-primary") ||
		document.querySelector(".elementor-button-info .elementor-button-text")
	) {
		document
			.querySelectorAll(
				".button-primary, .elementor-button-info .elementor-button-text"
			)
			.forEach(function (textsToSplit) {
				new SplitText(textsToSplit, {
					tag: "span",
					type: "words",
					wordsClass: "word",
				});
			});
	}

	if (document.querySelector("#ia-button")) {
		document.querySelector("#ia-button").classList.add("active"),
			setTimeout(function () {
				document.querySelector("#ia-button").classList.remove("active");
			}, 200);
	}

	if (document.querySelector("#domains > .triangle")) {
		if (
			document.querySelectorAll(".interventions-list .intervention").length == 4
		) {
			document
				.querySelectorAll(".interventions-list .intervention")
				.forEach((intervention) => {
					intervention.classList.add("no-marge");
				});
		}

		const triangle = document.querySelector("#domains > .triangle");
		const offsetY =
			document
				.querySelector("#domains .interventions-list")
				.getBoundingClientRect().y - triangle.getBoundingClientRect().y;
		const offsetX =
			document
				.querySelector("#domains .interventions-list > .intervention:first-child")
				.getBoundingClientRect().x - triangle.getBoundingClientRect().x;
		const scale =
			document
				.querySelector("#domains .interventions-list > .intervention:first-child")
				.getBoundingClientRect().width / triangle.getBoundingClientRect().width;
		gsap.set(triangle, {
			rotate: 391,
			scale: 0.5,
			x: (window.innerWidth / 4) * 3,
			y: 200,
			filter: "blur(30px)",
		});
		gsap.to(triangle, {
			scrollTrigger: {
				trigger: triangle,
				start: "top center",
				endTrigger: "#domains .interventions-list",
				end: "top center",
				scrub: true,
				onToggle: (e) => {
					if (e.direction == 1 && !e.isActive) {
						gsap.to(triangle, { opacity: 0 });
						document
							.querySelector("#domains .interventions-list")
							.classList.add("active");
					} else {
						gsap.to(triangle, { opacity: 1 });
						document
							.querySelector("#domains .interventions-list")
							.classList.remove("active");
					}
				},
			},
			motionPath: {
				path: [
					{ x: window.innerWidth / 2, y: 200 },
					{ x: window.innerWidth / 4, y: 300 },
					{ x: offsetX, y: offsetY },
				],
			},
			y: offsetY,
			x: offsetX,
			filter: "blur(0px)",
			scale: scale,
			rotate: 0,
		});

		let i = 1;
		document
			.querySelectorAll("#domains .intervention")
			.forEach(function (intervention) {
				intervention.addEventListener("mouseover", () => {
					const degree = 30;
					const newDegree = parseInt(degree) + 20 * i + "deg";
					gsap.to("#domains .background", {
						backgroundImage:
							"linear-gradient(" + newDegree + ", #f1f6f8 50%, #a2e8f0 100%)",
						duration: 2,
					});
					i++;
				});
			});
	}

	if (document.querySelector(".section-archive-interventions")) {
		let i = 1;
		document
			.querySelectorAll(".section-archive-interventions .intervention")
			.forEach(function (intervention) {
				intervention.addEventListener("mouseover", () => {
					const degree = 30;
					const newDegree = parseInt(degree) + 20 * i + "deg";
					gsap.to(".section-archive-interventions .background", {
						backgroundImage:
							"linear-gradient(" + newDegree + ", #f1f6f8 50%, #a2e8f0 100%)",
						duration: 2,
					});
					i++;
				});
			});
	}

	if (document.querySelector("#section-solutions")) {
		gsap.to("#section-solutions .mask", {
			scrollTrigger: {
				trigger: "#section-solutions",
				start: "top bottom",
				end: "top top",
				scrub: true,
			},
			scaleY: 1,
		});
	}

	if (document.querySelector(".section-archive-interventions")) {
		gsap.to(".section-hero-archive > svg", {
			scrollTrigger: {
				trigger: ".section-hero-archive",
				start: "top top",
				end: "bottom top",
				scrub: true,
			},
			scaleY: 3,
		});
	}

	if (document.querySelector(".team-scroll")) {
		const scrubValue = 0.5;

		let container = document.querySelector(".team-scroll .wrapper");
		let images = document.querySelectorAll(".team-scroll .wrapper .image");
		let containerWidth = 0;
		images.forEach(function (image) {
			containerWidth += image.getBoundingClientRect().width + 30;
		});
		gsap.set(container, { width: containerWidth });
		gsap.to(container, {
			xPercent: -100 + ((window.innerWidth / containerWidth) * 100 - 10),
			ease: "none",
			scrollTrigger: {
				trigger: container,
				pin: true,
				start: "top 50%-=350",
				scrub: 1,
				end: () => "+=" + (containerWidth - window.innerWidth),
			},
		});
	}

	document.querySelectorAll("a").forEach(function (link) {
		if (link.getAttribute("target") != "_blank" && !link.href.includes("#")) {
			link.addEventListener("click", () => {
				gsap.set("#page-preloader", { visibility: "visible" });
				gsap.to("#page-preloader .preloader__wrapper", { opacity: 1 });
			});
		}
	});

	if (document.querySelector(".footer__brandbar__brand .brand__logo")) {
		const logo = document.querySelector(
			".footer__brandbar__brand .brand__logo"
		);
		ScrollTrigger.create({
			trigger: logo,
			start: "top 50%",
			onToggle: (e) => {
				if (e.isActive) {
					logo.classList.add("active");
				} else {
					logo.classList.remove("active");
				}
			},
		});
	}

	if (document.querySelector(".big-number")) {
		const numbers = document.querySelectorAll(".big-number");
		numbers.forEach((number) => {
			ScrollTrigger.create({
				trigger: number,
				start: "top 80%",
				onToggle: (e) => {
					if (e.isActive) {
						number.classList.add("active");
					} else {
						number.classList.remove("active");
					}
				},
			});
		});
	}

	/*
if (document.querySelector(".--light")) {
	const offset = 32;
	window.addEventListener("scroll", (e) => {
		let isLightBackground = false;
		document.querySelectorAll(".--light").forEach(function (section) {
			if (
				section.getBoundingClientRect().top <= 0 + offset &&
				section.getBoundingClientRect().top +
					section.getBoundingClientRect().height >
					0 + offset
			) {
				isLightBackground = true;
			}
		});
		document
			.querySelector("#page-header")
			.classList.toggle("--dark", isLightBackground);
	});

	// at init
	let isLightBackground = false;
	document.querySelectorAll(".--light").forEach(function (section) {
		// console.log(section.getBoundingClientRect().top)
		if (
			section.getBoundingClientRect().top <= 0 + offset &&
			section.getBoundingClientRect().top +
				section.getBoundingClientRect().height >
				0 + offset
		) {
			isLightBackground = true;
		}
		// console.log(section.getBoundingClientRect().top <= 0 + offset);
	});
	// console.log(isLightBackground)
	document
		.querySelector("#page-header")
		.classList.toggle("--dark", isLightBackground);
}
*/
};

// Actions exécutées après le preLoader d'accueil
const afterPreloader = () => {
	document
		.querySelector(".page__preloader .brand__logo")
		.classList.remove("active");
	scrollEnabled(true);
	gsapDataAnimation();
	scrollToAnchor();
};

// GSAP : Rafraîchissement du ScrollSmoother (avec ScrollSmoother)
const gsapScrollSmootherRefresh = () => {
	if (scrollSmooth) {
		// Désactiver sur Élémentor
		if (document.querySelector("body.elementor-editor-active")) {
			scrollSmooth.kill();
		} else {
			scrollSmooth.refresh();
		}
	}
};

// GSAP : Gestion du preloader d'accueil
const gsapPreloader = () => {
	// Chargement des fonctions GSAP préalables
	// if (window.innerWidth > 992) initScrollSmooth();

	scrollEnabled(false);
	gsapSplitText();

	// Lancement de l'animation de chargement
	const loaderTimeline = gsap.timeline();
	document
		.querySelector(".page__preloader .brand__logo")
		.classList.add("active");
	if (document.querySelector(".page-home")) {
		loaderTimeline
			// animation
			.to("#page-preloader .brand__logo .celiance", {
				delay: 0.3,
				duration: 0.9,
				ease: "power3.in",
				opacity: 1,
				onComplete: () => {
					document
						.querySelector(".page__preloader .brand__logo")
						.classList.remove("active");
				},
			})
			.to("#page-preloader .preloader__wrapper", {
				duration: 0.6,
				ease: "power1.out",
				opacity: 0,
			})
			.set("#page-preloader", {
				visibility: "hidden",
			});
		// Functions succédentes
		loaderTimeline.add(afterPreloader, loaderTimeline.duration() - 0.3);
	} else {
		loaderTimeline
			// animation
			.to("#page-preloader .preloader__wrapper", {
				duration: 0.3,
				ease: "power1.out",
				opacity: 0,
			})
			.set("#page-preloader", {
				visibility: "hidden",
			});
		// Functions succédentes
		loaderTimeline.add(afterPreloader, loaderTimeline.duration() - 0.3);
	}
};
